import moment from 'moment';

export interface DeliveryForecast {
  label: string;
  value: string;
}

export const buildDeliveryForecast = (
  selectDate: string | null | undefined,
  numberOfDaysToSuplay: number | undefined
): DeliveryForecast => {
  if (!selectDate) {
    return { label: '', value: '' };
  }

  const start = moment(selectDate, 'YYYY-MM-DD');
  const startFmt = start.format('DD/MM/YYYY');

  if ((numberOfDaysToSuplay || 0) > 1) {
    const end = start
      .clone()
      .add((numberOfDaysToSuplay as number) - 1, 'days')
      .format('DD/MM/YYYY');
    return {
      label: 'Previsão de entrega entre',
      value: `${startFmt} a ${end}`,
    };
  }

  return { label: 'Previsão de entrega', value: startFmt };
};

export default buildDeliveryForecast;
